// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ModalBody from "../../../library/reuseable-components/ModalBody.bs.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ModalFooter from "../../../library/reuseable-components/ModalFooter.bs.js";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Column$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as RoundInputCheckbox from "./RoundInputCheckbox.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as PricingDashboardAssetsManager from "../../../../assets/PricingDashboardAssetsManager.bs.js";

var ab_modification_icon = PricingDashboardAssetsManager.getImage("ab-modification-icon.svg");

var simple_modification_icon = PricingDashboardAssetsManager.getImage("simple-modification-icon.svg");

function SelectModificationView$SelectOptionComponent(Props) {
  var is_selected = Props.is_selected;
  var icon = Props.icon;
  var title = Props.title;
  var helper_text = Props.helper_text;
  var on_click = Props.on_click;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "option " + (
                is_selected ? "selected" : ""
              )
            }, React.createElement("img", {
                  className: "icon",
                  src: icon
                }), React.createElement("div", {
                  className: "info"
                }, React.createElement("div", {
                      className: "title"
                    }, title), React.createElement("div", {
                      className: "helper-info"
                    }, helper_text)), React.createElement(RoundInputCheckbox.make, {
                  is_checked: is_selected,
                  on_click: on_click
                }));
}

var SelectOptionComponent = {
  make: SelectModificationView$SelectOptionComponent
};

function SelectModificationView(Props) {
  var onNext = Props.onNext;
  var match = React.useState(function () {
        
      });
  var update_modification_type = match[1];
  var modification_type = match[0];
  return React.createElement(React.Fragment, undefined, React.createElement(ModalBody.make, {
                  children: React.createElement(Column$Catalyst.make, {
                        children: null,
                        className: "c-select-modification-root"
                      }, React.createElement("div", {
                            className: "title"
                          }, "Modification Type"), React.createElement("div", {
                            className: "helper-txt"
                          }, "Select the type of Modification you wish to create"), React.createElement("div", {
                            className: "selection-options"
                          }, React.createElement(SelectModificationView$SelectOptionComponent, {
                                is_selected: Belt_Option.mapWithDefault(modification_type, false, (function (m) {
                                        return m === /* Simple */1;
                                      })),
                                icon: simple_modification_icon,
                                title: "Simple Modification",
                                helper_text: "Modify Core Pricing Campaign in certain areas, days, and/or time",
                                on_click: (function (param) {
                                    return Curry._1(update_modification_type, (function (param) {
                                                  return /* Simple */1;
                                                }));
                                  })
                              }), React.createElement(SelectModificationView$SelectOptionComponent, {
                                is_selected: Belt_Option.mapWithDefault(modification_type, false, (function (m) {
                                        return m === /* AB */0;
                                      })),
                                icon: ab_modification_icon,
                                title: "Modification Experiment",
                                helper_text: "Experiment with multiple variations by modifying Core Pricing Campaign",
                                on_click: (function (param) {
                                    return Curry._1(update_modification_type, (function (param) {
                                                  return /* AB */0;
                                                }));
                                  })
                              })))
                }), React.createElement(ModalFooter.make, {
                  children: React.createElement(PrimaryButton$Catalyst.make, {
                        buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                              TAG: /* Text */0,
                              _0: "Next"
                            }, Belt_Option.isNone(modification_type), (function (param) {
                                return Curry._1(onNext, modification_type !== undefined ? (
                                              modification_type ? /* SimpleForm */2 : /* ABForm */1
                                            ) : /* SelectModification */0);
                              }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn " + (
                              Belt_Option.isNone(modification_type) ? "e-disabled-btn" : ""
                            ), undefined, undefined)
                      })
                }));
}

var make = SelectModificationView;

export {
  ab_modification_icon ,
  simple_modification_icon ,
  SelectOptionComponent ,
  make ,
  
}
/* ab_modification_icon Not a pure module */
